import { rule } from '../../domain/badge-composition-rule.js';
import { extractNormalUrlParts } from '../../utils/url-utils.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const certificateUrlRules = composition => {
  const { isT0, sandboxEnvironment, hasProduct, hasProductWithId, planIs, variantIs } = composition.checkers;

  return [
    rule('certificate/shop')
      .set(() => ({
        input: {
          certificateUrl: composition._urlService.buildCertificateUrl(composition.badgeType.language)
        },
      })),

    rule('certificate/partnership')
      .when(planIs('premium').and(variantIs('island').or(variantIs('mid'))))
      .when(hasProduct)
      .set(() => ({
        input: {
          certificateUrl: composition._urlService.buildCertificateUrl(
            composition.badgeType.language,
            extractNormalUrlParts(composition.input.product.brand.brandUrl, {noWww: true}).host
          )
        },
      })),

    rule('certificate/product')
      .when(planIs('premium').and(variantIs('island').or(variantIs('mid'))))
      .when(hasProductWithId)
      .set(() => ({
        input: {
          certificateUrl: composition._urlService.buildCertificateUrl(
            composition.badgeType.language,
            extractNormalUrlParts(composition.input.product.brand.brandUrl, {noWww: true}).host,
            composition.input.product.id
          )
        },
      })),

    rule('certificate/none')
      .when(isT0.or(sandboxEnvironment))
      .set(() => ({
        input: {
          certificateUrl: ''
        },
      })),
  ];
};
